module.exports = __webpack_public_path__ + "media/images/osm_banner-50b92662a162f2a8afee91be198171ae.png";